import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Form from 'react-bootstrap/Form';
import { Button, Col, Row, Spinner } from 'react-bootstrap';
import { AuthViews } from '../../../views/Auth/_authView.const';
import LoginContent from './LoginContent';

function EmailValidateContent({
  validateEmail,
  loginAction,
  isUserPRO,
  passActiveView,
  emailValidated,
  loading,
  storeTokenAndRedirect,
}) {
  const VIEWS = [AuthViews.VALIDATE_EMAIL, AuthViews.LOGIN_REGISTER];
  const [activeView, setActiveView] = useState(AuthViews.VALIDATE_EMAIL);
  useEffect(() => {
    passActiveView(activeView);
    if (emailValidated) {
      if (isUserPRO) setActiveView(AuthViews.VALIDATE_EMAIL);
      else {
        setActiveView(AuthViews.LOGIN_REGISTER);
      }
    }
  }, [activeView, passActiveView, emailValidated, isUserPRO]);

  const formik = useFormik({
    initialValues: {
      username: '',
    },
    validationSchema: Yup.object({
      username: Yup.string().email('Invalid Username').required('Email required'),
    }),
    isInitialValid: false,
    onSubmit: (values) => {
      validateEmail(values);
      setNextView();
    },
  });

  const setPreviousView = () => {
    const currentIndex = VIEWS.findIndex((form) => form === activeView);
    setActiveView(VIEWS[currentIndex - 1]);
    window.location.reload();
  };

  const setNextView = () => {
    const currentIndex = VIEWS.findIndex((form) => form === activeView);
    if (activeView === AuthViews.VALIDATE_EMAIL) {
      setActiveView(VIEWS[0]);
    } else {
      setActiveView(VIEWS[currentIndex + 1]);
    }
  };

  const renderActiveView = () => {
    switch (activeView) {
      case AuthViews.VALIDATE_EMAIL:
        return (
          <Form onSubmit={formik.handleSubmit} className="pt-5" noValidate>
            <Form.Group>
              <Form.Label className="mb-0">Email </Form.Label>
              <Form.Control
                className="p-0 float-label"
                id="username"
                name="username"
                type="email"
                value={formik.values.username}
                onChange={formik.handleChange}
                placeholder="eg. abc@company.com"
                isInvalid={!!formik.errors.username}
              />
              <Form.Control.Feedback type="invalid">{formik.errors.username}</Form.Control.Feedback>
            </Form.Group>
            <Row>
              <Col xs="12">
                <Button
                  className="btn-block"
                  variant="primary"
                  size="lg"
                  disabled={!formik.isValid || loading}
                  type="submit">
                  {loading ? (
                    <div>
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                      <span> Logging</span>
                    </div>
                  ) : (
                    'Login'
                  )}
                </Button>
              </Col>
            </Row>
          </Form>
        );
      case AuthViews.LOGIN_REGISTER:
        return (
          <LoginContent
            setPreviousView={setPreviousView}
            email={formik?.values?.username}
            loginAction={loginAction}
          />
        );
      default:
        return <h2>Invalid View</h2>;
    }
  };

  return renderActiveView();
}

export default EmailValidateContent;
